<div class="reward-gb-image" [style.background-image]="'url(' + imageSrc + ')'"></div>
<div class="reward-gb-content">
  <div class="reward-gb-description">{{ description }}</div>
</div>
